<template>
  <v-card rounded="lg" height="600">
    <v-card-text>
      <div class="mt-4">
        <v-avatar size="60">
          <img src="../assets/captain.jpeg" alt="" />
        </v-avatar>
        <h2 class="my-1" style=" color: black;font-size: 17px;">
          Shedrach Yohanna
        </h2>
      </div>

      <div>
        <v-btn rounded color="#707070" class="white--text text-capitalize my-2">
          edit profile
        </v-btn>
      </div>
      <div class="d-flex flex-row flex-wrap my-3 ">
        <img
          src="../assets/ex.jpg"
          alt=""
          class="rounded-lg mx-1"
          width="70"
          height="60"
        />
        <img
          src="../assets/ex.jpg"
          alt=""
          class="rounded-lg mx-1"
          width="70"
          height="60"
        />
        <img
          src="../assets/ex.jpg"
          alt=""
          class="rounded-lg mx-1"
          width="70"
          height="60"
        />
      </div>
      <div>
        <v-card-title class="ma-0 pa-0 black--text" style="font-size: 15px">
          Bio
        </v-card-title>
      </div>
      <div>
        <p class="black--text">Instructor @KAD ICT HUB</p>
      </div>

      <div v-for="item in bio" :key="item.id">
        <p class="icon-text">
          <v-icon color="" left>{{ item.icon }}</v-icon>
          <span>{{ item.title }}</span>
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    bio: [
      {
        id: "1",
        title: "07016505825",
        icon: "mdi-phone",
      },
      {
        id: "2",
        title: "auwalrg@gmail.com",
        icon: "mdi-email",
      },
      {
        id: "3",
        title: "kad ict hub",
        icon: "mdi-medical-bag",
      },
      {
        id: "4",
        title: "kaduna",
        icon: "mdi-google-maps",
      },
    ],
  }),
};
</script>
